"use client";

import React, { ReactNode, useEffect, useState } from "react";
import { Typography } from "@aph/ui-lib-humanx";
import styles from "./SideBar.module.scss";

interface SideBarProps {
  title?: string;
  children?: ReactNode;
  isOpen?: boolean;
  isSideBarRightAlign?: boolean;
  showInSSR?: boolean;
  handleOpen?: (isOpen: boolean) => void;
  loginIcon?: string;
  loginCta?: (() => void) | null;
  loginText?: string;
  isLoggedIn?: boolean;
  logoutCta?: () => void;
  logoutIcon?: string;
}

const SideBar: React.FC<SideBarProps> = (props) => {
  const {
    title = "Welcome User",
    children,
    isOpen,
    isSideBarRightAlign = true,
    showInSSR = false,
    handleOpen,
    loginIcon = "icon-ic_arrow_right",
    loginCta,
    loginText = "Login/Sign Up",
    isLoggedIn,
    logoutCta,
    logoutIcon = "icon-logout",
  } = props;

  const [openSideBar, setOpenSideBar] = useState(isOpen);

  const closeSideBar = () => {
    setOpenSideBar(false);
    handleOpen && handleOpen(false);
  };

  const handleLoginCta = () => {
    loginCta && loginCta();
    closeSideBar();
  };

  const handleLogoutCta = () => {
    logoutCta && logoutCta();
    closeSideBar();
  };

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closeSideBar();
    }
  };

  useEffect(() => {
    setOpenSideBar(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (openSideBar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [openSideBar]);

  return (
    <>
      {(openSideBar || showInSSR) && (
        <div
          className={`${styles.root} ${isSideBarRightAlign ? styles.sideBarRightAlign : ""} ${
            showInSSR ? styles.ssrStyle : ""
          }`}
          onClick={handleBackdropClick}
        >
          <div className={styles.blackBg} onClick={closeSideBar} />
          <div className={styles.container}>
            <div className={styles.header}>
              <Typography component="h2" className={styles.title}>
                {title}
              </Typography>
              {!isLoggedIn && loginCta && (
                <div className={styles.subTitle} onClick={handleLoginCta}>
                  <Typography component="p">{loginText}</Typography>
                  <span className={loginIcon}></span>
                </div>
              )}
            </div>
            <div className={styles.contentBx}>
              {children}
              {isLoggedIn && (
                <div className={styles.logoutWrap} onClick={handleLogoutCta}>
                  <span className={`${styles.logoutIcon} ${logoutIcon}`} />
                  <span>Logout</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SideBar;
